import { Grid, IconButton, Tooltip } from '@mui/material'
import { format, startOfToday } from 'date-fns'
import {
  createContext,
  useCallback,
  useEffect,
  useState,
  useMemo,
  useContext,
} from 'react'
import { useImmerReducer } from 'use-immer'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { IoPersonCircleOutline } from 'react-icons/io5'
import { ConsultsList } from './components/schedule-calendar'
import { GlobalContext } from '../../../App'

const initialValues = {
  statics: {
    agendamentos: 0,
    preparacao: 0,
    confirmados: 0,
    aguardando: 0,
    atendido: 0,
    cancelado: 0,
    finalizado: 0,
  },
  consults: [],
  terapias: [],
  selectedDay: startOfToday(),
  agendamentoSelecionado: {
    modal: false,
    data: null,
  },
  medico: null,
}

const reducer = (state = initialValues, { type, field, value }) => {
  switch (type) {
    case 'setConsults':
      return { ...state, consults: value }
    case 'setTerapias':
      state.terapias = value
      return
    default:
      state[field] = value
  }
}
export const AgendaContext = createContext(initialValues)

const ProgramacaoAgendamento = () => {
  const { localAtendimento } = useContext(GlobalContext)
  const [ferramentas, setFerramentas] = useState()

  const [state, dispatch] = useImmerReducer(reducer, initialValues)

  const contextValues = useMemo(
    () => ({ ...state, dispatch }),
    [state, dispatch],
  )

  const { selectedDay } = state

  const vaiPrograma = (programa) => {
    window.location.href = programa
  }

  const listaAgendamentos = useCallback(() => {
    setFerramentas(
      <>
        <Tooltip title="Pacientes">
          <IconButton
            onClick={() => vaiPrograma('/programas/cadastro/paciente')}
          >
            <IoPersonCircleOutline />
          </IconButton>
        </Tooltip>
      </>,
    )
    if (localAtendimento !== undefined && localAtendimento?.[0] !== undefined) {
      metodoPrograma(
        'lista',
        {
          data: format(selectedDay, 'yyyy-MM-dd'),
          idLocalAtendimento: localAtendimento?.[0],
        },
        'CtrlProgramacaoAgendamento',
      ).then((res) => {
        if (res.status) {
          dispatch({ type: 'setConsults', value: res.lista })
          dispatch({ type: 'setTerapias', value: res.terapias })
        }
      })
    }
  }, [selectedDay, localAtendimento, dispatch])

  useEffect(() => {
    listaAgendamentos()
  }, [listaAgendamentos])

  return (
    <AgendaContext.Provider value={contextValues}>
      <Programa codigo={'CtrlProgramacaoAgendamento'} ferramentas={ferramentas}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <ConsultsList {...{ listaAgendamentos }} />
          </Grid>
        </Grid>
      </Programa>
    </AgendaContext.Provider>
  )
}

export default ProgramacaoAgendamento
